module.exports = __webpack_public_path__ + "static/media/offer-4.2084309c.png";